/**
 * Extract error message from API error response
 * Handles both string and object formats for error.response.data.detail
 * 
 * @param {Error} error - The axios error object
 * @param {string} fallback - Fallback message if no detail found
 * @returns {string} The error message string
 */
export const getErrorMessage = (error, fallback = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) {
    return fallback;
  }
  
  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }
  
  // If detail is an object with a message property (e.g., {code: "LIMIT_EXCEEDED", message: "..."})
  if (typeof detail === 'object' && detail.message) {
    return detail.message;
  }
  
  // If detail is an array (validation errors), join messages
  if (Array.isArray(detail)) {
    return detail.map(d => d.msg || d.message || String(d)).join(', ');
  }
  
  return fallback;
};
